// Roles whose email-change requests must go through Admin approval before the
// OTP-to-new-email step. Only ADMIN/SUPER_ADMIN can approve, so they're excluded.
export const REQUESTER_ROLES = ["COACH", "USER"];
